/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react';
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom';
import {PrivateRoutes} from './PrivateRoutes';
import {ErrorsPage} from '../modules/errors/ErrorsPage';
import {Logout, AuthPage, useAuth} from '../modules/auth';
import {App} from '../App';
import Unauthorized from '../modules/auth/components/Unauthorized';
import {ARModelPage} from '../modules/models-management/pages/ar-model/ARModelPage';
import {EmbeddedModelPage} from '../modules/models-management/pages/shared/EmbeddedModelPage';
import {SharedModelPage} from '../modules/models-management/pages/shared/SharedModelPage';
import TryItButtonEmbedPage from '../modules/models-management/pages/shared/TryItButtonEmbedPage';
import VideoSharedPage from '../modules/videos/pages/VideoSharedPage';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env;

const AppRoutes: FC = () => {
  const {currentUser} = useAuth();
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='models/try-it' element={<TryItButtonEmbedPage />} />
          <Route path='models/ar-app' element={<ARModelPage />} />
          <Route path='models/share' element={<SharedModelPage />} />
          <Route path='models/embed' element={<EmbeddedModelPage />} />

          <Route path='videos/share' element={<VideoSharedPage />} />

          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='unauthorized' element={<Unauthorized />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              {/* <Route index element={<Navigate to='/dashboard' />} /> */}
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export {AppRoutes};
